<div class="main">
    <h2 translate>home.lblExecuteFileTransfers</h2>
    <div class="flex">
        <div class="left" *ngIf="environments.length > 0 && selectedEnvironment">
            <app-environment-picker [environments]="environments" [(selectedItem)]="selectedEnvironment"
                                    (selectedItemChange)="setFilteredFileTransfers()"></app-environment-picker>
        </div>
        <div class="right">
            <app-file-transfer-picker [fileTransfers]="filteredFileTransfers" [(selectedItem)]="selectedFileTransfer"></app-file-transfer-picker>
        </div>
    </div>

    <div class="center">
        <dx-button [disabled]="!this.selectedFileTransfer || this.isTransferInProgress"
                   [text]="'_commons.execute' | translate"
                   (onClick)="executeFileTransfer()"></dx-button>
    </div>
    <br />
    <div class="center" *ngIf="isTransferInProgress">
        <dx-progress-bar #progressBar
                         id="progress-bar-status"
                         max="3"
                         min="0"
                         width="100%"
                         [height]="15"
                         [showStatus]="false"
                         [value]="transferStep" />
        <span>{{ transferProgression }}</span>
    </div>
</div>

<!-- Display popup -->
<app-local-agent-command #agentCommandPopup></app-local-agent-command>

<!-- Loading panel -->
<dx-load-panel [visible]="isLoadPanelVisible" [message]="'_commons.loading' | translate" [position]="{ of: '.app-content', boundary: '.app-content' }"></dx-load-panel>
